import React from "react";
import { Spinner, SpinnerProps } from "reactstrap";

// styles
import styles from "./LoadingComponent.module.scss";

interface SpinnerAProps extends SpinnerProps {}

const LoadingComponent = ({ ref, ...rest }: SpinnerAProps) => {
  return (
    <div className={styles.loading}>
      <Spinner children="" type="grow" color="primary" {...rest} />
    </div>
  );
};

export default LoadingComponent;
